import styled from 'styled-components';

export const Call2Actions = styled.div.attrs({
    className: 'home-call2actions',
})`
    display: flex;
    flex-wrap: wrap;
    margin: 4rem 0 0 -2rem;
    & > * {
        flex: 1 1 auto;
        margin-top: 0;
        margin-bottom: 4rem;
        margin-left: 2rem;
        min-width: 290px;
    }
    & + * {
        margin-top: 0;
    }
`;
